/**
 * Motivos de consulta predefinidos para Cita Rápida — Cosmetología.
 * 
 * Cada motivo se asigna a un tratamiento existente en la clínica.
 * Si el tratamiento no existe, el backend lo crea automáticamente.
 */
const MOTIVOS_COSMETOLOGIA = [
  { id: 'cos_limp_facial', label: '✨ Limpieza facial profunda', tratamiento: 'limpieza_facial', duracion: 75 },
  { id: 'cos_radiofreq', label: '🔆 Radiofrecuencia facial', tratamiento: 'radiofrecuencia', duracion: 60 },
  { id: 'cos_peeling', label: '🧪 Peeling químico', tratamiento: 'peeling', duracion: 45 },
  { id: 'cos_drenaje', label: '💆 Drenaje linfático', tratamiento: 'drenaje_linfatico', duracion: 75 },
  { id: 'cos_depilacion', label: '🦵 Depilación láser', tratamiento: 'depilacion_laser', duracion: 45 },
  { id: 'cos_pestañas', label: '💅 Pestañas pelo a pelo', tratamiento: 'pestañas', duracion: 90 },
  { id: 'cos_ultracav', label: '🏋️ Ultracavitación', tratamiento: 'ultracavitacion', duracion: 45 },
  { id: 'cos_otro', label: '🎯 Otro tratamiento estético', tratamiento: 'general_cosmeto', duracion: 60 },
];

export default MOTIVOS_COSMETOLOGIA;
